import React, { useState, useRef, useEffect } from 'react'

const API = process.env.REACT_APP_BACKEND_URL

const MODES = [
  { id: 'ass', label: 'ASS', field: 'est_amiable', value: false, color: 'bg-blue-100 text-blue-700 border-blue-200', activeColor: 'bg-blue-600 text-white', desc: 'Assurance' },
  { id: 'ami', label: 'AMI', field: 'est_amiable', value: true, color: 'bg-teal-100 text-teal-700 border-teal-200', activeColor: 'bg-teal-600 text-white', desc: 'Amiable' },
]

const FLAGS = [
  { id: 'mec', label: 'MEC', field: 'est_mise_en_cause', color: 'bg-red-100 text-red-700 border-red-200', activeColor: 'bg-red-600 text-white', desc: 'Mise en cause' },
  { id: 'cons', label: 'CONS', field: 'est_conservatoire', color: 'bg-amber-100 text-amber-700 border-amber-200', activeColor: 'bg-amber-600 text-white', desc: 'Conservatoire' },
]

export default function BadgesCell({ sinistre, onUpdated }) {
  const [open, setOpen] = useState(false)
  const [saving, setSaving] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    function handleClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false)
    }
    if (open) document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [open])

  const isAmiable = sinistre.est_amiable
  const isMec = sinistre.est_mise_en_cause
  const isCons = sinistre.est_conservatoire != null
    ? sinistre.est_conservatoire
    : !sinistre.numero_dossier_compagnie

  async function patchField(payload) {
    setSaving(true)
    try {
      const res = await fetch(`${API}/api/sinistres/${sinistre.id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
      if (res.ok && onUpdated) onUpdated()
    } finally {
      setSaving(false)
    }
  }

  function setMode(amiable) {
    patchField({ est_amiable: amiable, mode_gestion: amiable ? 'amiable' : 'assurance' })
  }

  function toggleFlag(field) {
    const payload = {}
    payload[field] = !sinistre[field]
    patchField(payload)
  }

  return (
    <div className="relative" ref={ref} onClick={e => e.stopPropagation()}>
      <div
        className="flex items-center gap-1 cursor-pointer min-w-[60px]"
        onClick={() => setOpen(!open)}
        data-testid="badges-cell"
      >
        {/* Mode badge */}
        {isAmiable ? (
          <span className="px-1.5 py-0.5 text-[9px] font-bold bg-teal-100 text-teal-700 rounded border border-teal-200" data-testid="badge-ami">AMI</span>
        ) : (
          <span className="px-1.5 py-0.5 text-[9px] font-bold bg-blue-100 text-blue-700 rounded border border-blue-200" data-testid="badge-ass">ASS</span>
        )}
        {/* MEC badge */}
        {isMec && (
          <span className="px-1.5 py-0.5 text-[9px] font-bold bg-red-100 text-red-700 rounded border border-red-200" data-testid="badge-mec">MEC</span>
        )}
        {/* CONS badge */}
        {isCons && (
          <span className="px-1.5 py-0.5 text-[9px] font-bold bg-amber-100 text-amber-700 rounded border border-amber-200" data-testid="badge-cons">CONS</span>
        )}
      </div>

      {open && (
        <div className="absolute z-50 left-0 top-full mt-1 bg-white rounded-lg shadow-xl border border-slate-200 p-2 min-w-[160px]"
             data-testid="badges-dropdown">
          <p className="text-[10px] font-semibold text-slate-400 uppercase tracking-wide px-1 mb-1">Mode</p>
          {MODES.map(m => {
            const active = m.value === isAmiable
            return (
              <button
                key={m.id}
                onClick={() => setMode(m.value)}
                disabled={saving}
                className={`w-full flex items-center justify-between px-2 py-1.5 rounded text-xs font-medium transition-colors mb-0.5 ${
                  active ? m.activeColor : 'bg-slate-50 text-slate-500 hover:bg-slate-100'
                }`}
                data-testid={`set-mode-${m.id}`}
              >
                <span>{m.label} — {m.desc}</span>
              </button>
            )
          })}
          <div className="border-t border-slate-100 mt-1.5 pt-1.5">
            <p className="text-[10px] font-semibold text-slate-400 uppercase tracking-wide px-1 mb-1">Drapeaux</p>
            {FLAGS.map(f => {
              const active = f.id === 'mec' ? isMec : isCons
              return (
                <button
                  key={f.id}
                  onClick={() => toggleFlag(f.field)}
                  disabled={saving}
                  className={`w-full flex items-center justify-between px-2 py-1.5 rounded text-xs font-medium transition-colors mb-0.5 ${
                    active ? f.activeColor : 'bg-slate-50 text-slate-500 hover:bg-slate-100'
                  }`}
                  data-testid={`toggle-${f.id}`}
                >
                  <span>{f.label} — {f.desc}</span>
                  {active && <span className="text-[10px]">ON</span>}
                </button>
              )
            })}
          </div>
        </div>
      )}
    </div>
  )
}
